'use strict';

// Pull in the styles ...
import './main/scss/main.scss';

import React from 'react';
import {HashRouter, Route, Routes} from 'react-router-dom';

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import {AppContext} from "@uw-it-sis/lib-react/lib/AppContext";
import Solstice from "@uw-it-sis/lib-react/lib/Solstice";
import history from '@uw-it-sis/lib-react/lib/History';
import {render} from '@uw-it-sis/lib-react/lib/Render';

import AuditConsole from "./main/js/console/AuditConsole";

/**
 * Define the routes.
 */
const routes =
    <Routes>
        <Route path="" element={<AuditConsole />} />
        <Route path=":activeTab" element={<AuditConsole />} />
        <Route path=":activeTab/*" element={<AuditConsole />} />
    </Routes>;

/**
 * Put the AppStore in the React context so that it's available to any class that needs it.
 */
const router = (
    <AppContext.Provider value={{
        appStore: appStore,
        history: history
    }}>
        <HashRouter>
            <Solstice
                name="console"
                title="Audit Console"
                fluid={true}
                condensed={true}
                routes={routes}
                enableBannerMessages={false}
            />
        </HashRouter>
    </AppContext.Provider>
);

render(router);
